// extracted by mini-css-extract-plugin
module.exports = {"promoPartOne":"az__nc","promoPartTwo":"az_aoc","promoCode":"az_boc"};